// Script melhorado para calculadora de frete que funciona mesmo com carrinho vazio
// Adiciona temporariamente o produto ao carrinho para calcular frete, depois remove

document.addEventListener("DOMContentLoaded", function () {
  const shippingCalculators = document.querySelectorAll("shipping-calculator");

  shippingCalculators.forEach(function (calculator) {
    const countrySelect = calculator.querySelector(".js-country-select");
    const provinceSelect = calculator.querySelector(".js-province-select");
    const zipInput = calculator.querySelector(".js-zip-input");
    const loadingDiv = calculator.querySelector(".js-cep-loading");
    const calcButton = calculator.querySelector('button[type="button"]');

    if (countrySelect && zipInput && provinceSelect && calcButton) {
      // Define Brasil como padrão sempre
      countrySelect.value = "Brazil";

      // Dispara evento de mudança para carregar estados do Brasil
      const changeEvent = new Event("change", { bubbles: true });
      countrySelect.dispatchEvent(changeEvent);

      // Mapeamento de UF para nomes completos dos estados do Brasil
      const estadosBrasil = {
        AC: "Acre",
        AL: "Alagoas",
        AP: "Amapá",
        AM: "Amazonas",
        BA: "Bahia",
        CE: "Ceará",
        DF: "Distrito Federal",
        ES: "Espírito Santo",
        GO: "Goiás",
        MA: "Maranhão",
        MT: "Mato Grosso",
        MS: "Mato Grosso do Sul",
        MG: "Minas Gerais",
        PA: "Pará",
        PB: "Paraíba",
        PR: "Paraná",
        PE: "Pernambuco",
        PI: "Piauí",
        RJ: "Rio de Janeiro",
        RN: "Rio Grande do Norte",
        RS: "Rio Grande do Sul",
        RO: "Rondônia",
        RR: "Roraima",
        SC: "Santa Catarina",
        SP: "São Paulo",
        SE: "Sergipe",
        TO: "Tocantins",
      };

      // Função para formatar CEP brasileiro
      function formatCEP(value) {
        value = value.replace(/\D/g, "");
        if (value.length > 5) {
          value = value.slice(0, 5) + "-" + value.slice(5, 8);
        }
        return value;
      }

      // Função para buscar dados do CEP
      async function buscarCEP(cep) {
        try {
          const cepLimpo = cep.replace(/\D/g, "");
          if (cepLimpo.length !== 8) return null;

          if (loadingDiv) {
            loadingDiv.style.display = "block";
          }

          const response = await fetch(
            `https://viacep.com.br/ws/${cepLimpo}/json/`
          );
          const data = await response.json();

          if (loadingDiv) {
            loadingDiv.style.display = "none";
          }

          if (data.erro) return null;

          return {
            uf: data.uf,
            cidade: data.localidade,
            bairro: data.bairro,
            logradouro: data.logradouro,
          };
        } catch (error) {
          console.log("Erro ao buscar CEP:", error);
          if (loadingDiv) {
            loadingDiv.style.display = "none";
          }
          return null;
        }
      }

      // Função para selecionar o estado no select
      function selecionarEstado(uf) {
        const nomeEstado = estadosBrasil[uf];
        if (nomeEstado) {
          const options = provinceSelect.options;
          for (let i = 0; i < options.length; i++) {
            if (
              options[i].text === nomeEstado ||
              options[i].value === nomeEstado
            ) {
              provinceSelect.selectedIndex = i;
              break;
            }
          }
        }
      }

      // Função para obter o produto atual da página
      function getCurrentProduct() {
        try {
          // Tenta encontrar o produto de diferentes formas
          const productForm = document.querySelector(
            'form[action*="/cart/add"]'
          );
          if (productForm) {
            const variantInput = productForm.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
              return variantInput.value;
            }
          }

          // Fallback: procura por data-product-id
          const productElement = document.querySelector("[data-product-id]");
          if (productElement) {
            const productId = productElement.getAttribute("data-product-id");
            // Precisa da variant ID, não product ID
            const variantSelect = document.querySelector('[name="id"]');
            if (variantSelect && variantSelect.value) {
              return variantSelect.value;
            }
          }

          return null;
        } catch (error) {
          console.log("Erro ao obter produto atual:", error);
          return null;
        }
      }

      // Função principal para calcular frete com produto temporário
      async function calcularFreteComProduto(zip, country, province) {
        const errors = calculator.querySelector(".js-errors");
        const rates = calculator.querySelector(".js-rates");
        const button = calculator.querySelector("button");

        try {
          // Esconde resultados anteriores
          if (errors) errors.hidden = true;
          if (rates) rates.hidden = true;

          button.disabled = true;
          button.textContent = "Calculando frete...";
          button.classList.add("is-loading");

          // 1. Verifica se já tem produto no carrinho
          const cartResponse = await fetch("/cart.json");
          const cartData = await cartResponse.json();

          let needsRestore = false;
          let originalCart = null;

          // 2. Se carrinho vazio, adiciona produto temporariamente
          if (!cartData.items || cartData.items.length === 0) {
            const currentVariantId = getCurrentProduct();
            if (!currentVariantId) {
              throw new Error(
                "Não foi possível identificar o produto para calcular o frete"
              );
            }

            // Salva estado original do carrinho
            originalCart = cartData;
            needsRestore = true;

            // Adiciona produto temporariamente
            const addResponse = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: currentVariantId,
                quantity: 1,
              }),
            });

            if (!addResponse.ok) {
              throw new Error("Erro ao adicionar produto temporário");
            }

            // Aguarda um momento para o carrinho ser atualizado
            await new Promise((resolve) => setTimeout(resolve, 200));
          }

          // 3. Calcula frete
          const params = `shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;

          const shippingResponse = await fetch(
            `/cart/shipping_rates.json?${params}`
          );
          const shippingData = await shippingResponse.json();

          // 4. Se adicionou produto temporariamente, limpa o carrinho
          if (needsRestore) {
            try {
              await fetch("/cart/clear.js", { method: "POST" });
            } catch (clearError) {
              console.log(
                "Aviso: Não foi possível limpar carrinho temporário:",
                clearError
              );
            }
          }

          // 5. Mostra resultados
          if (shippingResponse.ok) {
            showRatesResult(calculator, shippingData);
          } else {
            showErrorsResult(
              calculator,
              shippingData || { error: "Erro ao calcular frete" }
            );
          }
        } catch (error) {
          console.log("Erro no cálculo de frete:", error);
          showErrorsResult(calculator, {
            error: "Erro ao calcular frete. Tente novamente.",
          });
        } finally {
          button.classList.remove("is-loading");
          button.disabled = false;
          button.textContent = "Calcular frete";
        }
      }

      // Aplica formatação em tempo real para CEP
      zipInput.addEventListener("input", function (e) {
        const cursorPosition = e.target.selectionStart;
        const formattedValue = formatCEP(e.target.value);
        e.target.value = formattedValue;

        // Ajusta a posição do cursor
        if (formattedValue.length === 6 && cursorPosition === 5) {
          e.target.setSelectionRange(6, 6);
        }
      });

      // Busca o estado quando o CEP está completo
      zipInput.addEventListener("blur", async function (e) {
        const cep = e.target.value;
        if (cep.length === 9) {
          await processarCEPCompleto(cep);
        }
      });

      // Função para processar CEP e calcular frete automaticamente
      async function processarCEPCompleto(cep) {
        try {
          calcButton.disabled = true;
          calcButton.textContent = "Buscando localização...";
          calcButton.classList.add("is-loading");

          // 1. Busca dados do CEP
          const dadosCEP = await buscarCEP(cep);
          if (!dadosCEP) {
            throw new Error("CEP não encontrado");
          }

          // 2. Seleciona o estado automaticamente
          calcButton.textContent = "Selecionando estado...";
          await new Promise((resolve) => {
            setTimeout(() => {
              selecionarEstado(dadosCEP.uf);
              resolve();
            }, 300);
          });

          // 3. Calcula frete automaticamente
          calcButton.textContent = "Calculando frete...";
          await calcularFreteComProduto(cep, "Brazil", provinceSelect.value);
        } catch (error) {
          console.log("Erro ao processar CEP:", error);
          calcButton.classList.remove("is-loading");
          calcButton.disabled = false;
          calcButton.textContent = "Calcular frete";

          zipInput.style.borderColor = "#ff4444";
          setTimeout(() => {
            zipInput.style.borderColor = "";
          }, 3000);
        }
      }

      // Intercepta clique no botão para calcular frete
      calcButton.addEventListener("click", async function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const cepPattern = /^[0-9]{5}-[0-9]{3}$/;
        if (!cepPattern.test(zipInput.value)) {
          zipInput.style.borderColor = "#ff4444";
          zipInput.focus();
          setTimeout(() => {
            zipInput.style.borderColor = "";
          }, 3000);
          return;
        }

        // Se não tem estado selecionado, busca automaticamente
        if (!provinceSelect.value || provinceSelect.selectedIndex === 0) {
          await processarCEPCompleto(zipInput.value);
        } else {
          // Se já tem estado, calcula diretamente
          await calcularFreteComProduto(
            zipInput.value,
            "Brazil",
            provinceSelect.value
          );
        }
      });

      // Se já houver um valor, formata
      if (zipInput.value) {
        zipInput.value = formatCEP(zipInput.value);
      }
    }
  });

  // Função para mostrar resultados
  function showRatesResult(calculator, data) {
    const rates = calculator.querySelector(".js-rates");
    const headingEl = rates.querySelector(".js-rates-heading");
    const textEl = rates.querySelector(".js-rates-text");
    textEl.innerHTML = "";

    if (data.shipping_rates && data.shipping_rates.length) {
      let ratesHTML = "";
      data.shipping_rates.forEach((rate) => {
        // Formata o preço
        let formattedRate = rate.price;
        if (window.theme?.settings?.moneyWithCurrencyFormat) {
          formattedRate = window.theme.settings.moneyWithCurrencyFormat.replace(
            /\{\{\s*(\w+)\s*\}\}/g,
            rate.price
          );
        } else {
          // Fallback: assume que price vem em centavos
          const priceInReais =
            typeof rate.price === "string"
              ? rate.price
              : `R$ ${(rate.price / 100).toFixed(2).replace(".", ",")}`;
          formattedRate = priceInReais;
        }

        ratesHTML += `<li><strong>${rate.name}</strong>: ${formattedRate}</li>`;
      });

      headingEl.hidden = false;
      headingEl.textContent =
        data.shipping_rates.length === 1
          ? "Opção de entrega:"
          : "Opções de entrega:";
      textEl.innerHTML = `<ul class="styled-list">${ratesHTML}</ul>`;
    } else {
      headingEl.hidden = true;
      textEl.innerHTML = "Nenhuma opção de entrega disponível para este CEP.";
    }

    rates.hidden = false;
  }

  // Função para mostrar erros
  function showErrorsResult(calculator, data) {
    const errors = calculator.querySelector(".js-errors");
    let errorsHTML = "";

    if (typeof data === "object" && data !== null) {
      Object.keys(data).forEach((key) => {
        errorsHTML += `<li>${data[key]}</li>`;
      });
    } else {
      errorsHTML = `<li>Erro ao calcular frete. Verifique o CEP e tente novamente.</li>`;
    }

    errors.querySelector(
      ".js-errors-text"
    ).innerHTML = `<ul class="styled-list">${errorsHTML}</ul>`;
    errors.hidden = false;
  }
});
